import React from "react";
import aboutData from "../data/about.json";

const AboutUs2 = () => {
  const { greeting, name, email, location, years_of_experience, paragraphs } =
    aboutData;

  return (
    <section id="about" className="section">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">About Me</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Know Me More
        </h2>
        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              {greeting}
              <span className="fw-700 border-bottom border-3 border-primary"></span>
            </h2>
            {paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className={`text-4${index === paragraphs.length - 1 ? " mb-0" : ""}`}
              >
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp" data-wow-delay="0.2s">
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">
                  {years_of_experience}
                </span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                Years of <span className="fw-700">Experience</span>
              </h3>
            </div>
          </div>
        </div>
        <div className="row gy-3 mt-4">
          <div className="col-6 col-lg-4 wow fadeInUp">
            <p className="text-muted fw-500 mb-0">Name:</p>
            <p className="text-4 text-dark fw-600 mb-0">{name}</p>
          </div>
          <div className="col-6 col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
            <p className="text-muted fw-500 mb-0">Email:</p>
            <p className="text-4 text-dark fw-600 mb-0">
              <a className="link-dark word-wrap" href={`mailto:${email}`}>
                <span className="word-wrap">{email}</span>
              </a>
            </p>
          </div>
          <div className="col-6 col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
            <p className="text-muted fw-500 mb-0">From:</p>
            <p className="text-4 text-dark fw-600 mb-0">{location}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs2;
